<template>
    <!-- Start Main Content -->
    <div v-show="!isBarcodePrint" class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
            <h2 class="card-title">Product List</h2>
             <button type="reset" @click="printBarcode" class="btn b-light btn-danger-light btn-sm">Barcode</button>
        </div>
        <div class="grid grid-cols-12">
            <!-- INITIALIZE CSS CLASS -->
            <div class="hidden">
                <div class="self-center md:col-span-6 md:place-self-end lg:col-span-full inline-block w-auto ml-2 dark:bg-dark-card-two dark:text-white align-middle"></div>
                <div class="hover:bg-primary-500 hover:text-white dark:bg-gray-800 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"></div>
                <div class="text-slate-300 border-slate-300 dark:!bg-gray-400 dark:text-slate-300 bg-slate-200/50 first:rounded-l-lg last:rounded-r-lg"></div>
                <div class=" dark:bg-gray-700 dark:!rounded-none transition-all duration-150 ease-linear [&.selected]:bg-[#F2F4F9] dark:[&.selected]:bg-dark-icon"></div>
                <div class="group-[.bordered]:rounded-none group-[.bordered]:border group-[.bordered]:border-gray-200 dark:group-[.bordered]:border-dark-border"></div>
            </div>
            <!-- INITIALIZE CSS CLASS -->
            <div class="tablejs sr-only size-0"></div>
            <!-- BASIC DATA TABLE -->
            <div class="col-span-full">
                <div class="card p-0">
                    <div class="p-6 space-y-4">
                        <table id="basicDataTable" class="datatable">
                            <thead>
                                <tr>
                                    <th class="bg-[#B2E8D9]">Checkbox</th>
                                    <th class="bg-[#B2E8D9]">SR</th>
                                    <th class="bg-[#B2E8D9]">Category</th>
                                    <th class="bg-[#B2E8D9]">Barcode</th>
                                    <th class="bg-[#B2E8D9]">HSN</th>
                                    <th class="bg-[#B2E8D9]">Name</th>
                                    <th class="bg-[#B2E8D9]">Unit</th>
                                    <th class="bg-[#B2E8D9]">GST</th>
                                    
                                    <th class="bg-[#B2E8D9]">MRP</th>
                                    <th class="bg-[#B2E8D9]">Purchase Rate</th>
                                    <th class="bg-[#B2E8D9]">Sale rate</th>
                                    <th class="bg-[#B2E8D9]">Stitch rate</th>
                                    <th class="bg-[#B2E8D9]">Set Rate</th>
                                    <th class="bg-[#B2E8D9]">Set Quantity</th> 
                                    <th class="bg-[#B2E8D9]">Stock </th> 
                                    <th class="bg-[#B2E8D9]">Stock Value</th> 
                                    <th class="bg-[#B2E8D9]">Barcode</th> 
                                </tr>
                            </thead>
                            <tbody class="divide-y divide-gray-200 dark:divide-dark-border">
                                <tr v-for="(item ,index)  in productsList" :key="item.id">
                                    <td><input type="checkbox" @click="barcode_select(item)"/></td>
                                    <td>{{index+1}}</td>
                                    <td>{{item.cat_name}}</td>
                                    <td>{{item.barcode}}</td>
                                    <td>{{item.hsn}}</td>
                                    <td>{{item.name}}</td>
                                    <td>{{item.unit}}</td>
                                    <td>{{item.gst}}</td>
                                    <td>{{item.mrp}}</td>
                                    <td>{{item.prate}}</td>
                                    <td>{{item.salerate}}</td>
                                    <td>{{item.stich_rate}}</td>
                                    <td>{{item.set_rate}}</td>
                                    <td>{{item.set_qty}}</td> 
                                    <td>{{item.stock}}</td> 
                                    <!-- <td> {{(item.prate>0)?parseFloat(item.prate)*parseFloat(item.stock):0}}</td>  -->
                                     <td>{{ (item.prate > 0) ? (parseFloat(item.prate) * parseFloat(item.stock)).toFixed(2) : '0.00' }}</td>

                                      <td class="px-3.5 py-4">
                                    <div class="flex items-center gap-1">
                                        <button class="btn-icon btn-danger-icon-light size-7" @click="editProduct(item.id)" >
                                           <i class="ri-edit-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                        </button>
                                        <button class="btn-icon btn-danger-icon-light size-7" @click="view_barcode(item.id)" >
                                           <i class="ri-barcode-line text-gray-900 dark:text-dark-text text-[14px]"></i>
                                        </button>
                                         <button class="btn-icon btn-danger-icon-light size-7" @click="deleteModal(item.id)" >
                                                <i class="ri-delete-bin-line text-danger text-[13px]"></i>
                                            </button>
                                    </div>
                                        </td> 
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                    <!-- Prism Code -->
                    <div class="p-6 hidden">
                        <pre>
                            <code class="language-markup">
                                &lt;p>Sorry we can't show the huge data table&lt;/p>
                            </code>
                        </pre>
                    </div>
                    <!-- Prism Code -->
                </div>
            </div>
            <!-- BORDERED SELECTION DELETION DATA TABLE -->
            
        </div>
    </div>
    <!-- End Main Content -->
       <!-- Start Delete Modal -->
       
    <BarcodeComp :GetproductsList="productsList" v-if='isBarcodePrint' @hideprintBarcode="printBarcode"/> 
       
    <div id="deleteModal" tabindex="-1" class="hidden fixed inset-0 z-modal flex-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full" style="    background: #00000052;">
        <div class="p-4 w-full max-w-md max-h-full">
            <div class="relative bg-white dark:bg-dark-tooltip rounded-lg shadow dk-theme-card-square">
                <button type="button" @click="closeModal" class="absolute top-3 end-2.5 text-gray-500 dark:text-dark-text hover:bg-gray-200 dark:hover:bg-dark-icon rounded-lg size-8 flex-center dk-theme-card-square">
                    <i class="ri-close-line text-inherit text-xl leading-none"></i>
                </button>
                <div class="p-4 md:p-5 text-center">
                    <img src="assets/images/icons/delete-record.png" alt="delete" class="block h-12 mx-auto">
                    <div class="mt-5 text-center">
                        <h5 class="mb-1">Are you sure?</h5>
                        <p class="text-slate-500 dark:text-zink-200">Are you certain you want to delete this record?</p>
                        <div class="flex justify-center gap-2 mt-6">
                            <button type="reset" @click="closeModal" class="btn b-light btn-danger-light btn-sm">Cancel</button>
                            <button type="submit" @click="delete_category" class="btn b-solid btn-danger-solid btn-sm">Yes, Delete It!</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- End Delete Modal -->
    
    
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';
import BarcodeComp from '@/components/BarcodeComp.vue'

export default {
name: 'AddProduct',
components: {
 BarcodeComp
} ,
mounted(){
 this.getBasics();
},
data() {
 return {
     isBarcodePrint:false,
     isAdd:0,
     isEdit:0,
     isDelete: 0,
     deleteId: 0,
     productsList:[],
     barcode_productsList:[],
     datatable:null,
     product:{name:'',cat:'0',barcode:'',hsn:'',descr:'',gst:'5',unit:'',mrp:'0',prate:'0',salerate:'0',set_rate:'0',set_qty:'0',},
     employees: {empname:'',emprole:'0',isMainAdmin:0},
 }
 }, 
methods:{
    printBarcode(){
      this.isBarcodePrint =!this.isBarcodePrint;
    },
    barcode_select(item){
        try {
            if(item.checked)
                item.checked=0;
            else
                item.checked=1;
            
        } catch (e) {
            item.checked=1;
        }
    },
    
 closeModal(){
     
    $("#editModal").addClass('hidden');
            $("#deleteModal").addClass('hidden');
        this.isAdd=0;
        this.isEdit=0;
        this.isDelete=0;
        this.deleteId=0;
 },
 addModal(){
     this.cat={name:'',status:'Active'};
     if(!this.isAdd)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isAdd=!this.isAdd;
 },

 editModal(item){
     if(item){
         let copy = JSON.parse(JSON.stringify(item));
         this.cat=copy;
     }
     if(!this.isEdit)
         $("#editModal").removeClass('hidden');
     else
         $("#editModal").addClass('hidden');
     this.isEdit=!this.isEdit;
 },
 
 deleteModal(id){
    this.deleteId=id;
     if(!this.isDelete)
         $("#deleteModal").removeClass('hidden');
     else
         $("#deleteModal").addClass('hidden');
     this.isDelete=!this.isDelete;
 },
 async getBasics() {
       var self=this;
         axios.post('getProducts').then(function (response) {
                 self.productsList=response.data.products;
                 self.employees=response.data.userDetails;
                }).then(()=>{ 
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
              
                    });;
  }, 
        view_barcode(id) {
            var self = this;
            window.open(window.location.origin+'/Barcode?q='+id,'_blank');
        },
        editProduct(id) {
            var self = this;
            // window.open(window.location.origin+'/addproduct?q='+id,'_blank');
             window.location.href = window.location.origin + '/addproduct?q=' + id;
        },
        
            delete_category() {
                var self = this; 
                axios.post('deleteProduct', {deleteId:this.deleteId})
                    .then(response => {
                        self.productsList=response.data.products;
                        self.employees=response.data.userDetails; 
                         self.closeModal(); 
                    })
                    .catch(error => {
                        console.log('Error on Authentication: ' + error);
                    });
            },
}
}
</script>
